/* eslint-disable react/jsx-pascal-case */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { TableVirtuoso } from 'react-virtuoso'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableBody from '@material-ui/core/TableBody'
import O_TableBar from 'components/3_Organisms/O_TableBar'
import O_TableRowJokenMobileSummary from 'components/3_Organisms/O_TableRowJokenMobileSummary'
import O_TableHeaderJokenMobileSummary from 'components/3_Organisms/O_TableHeaderJokenMobileSummary'
import { organismGroupLog } from 'utils/logUtil'
import { groupList } from 'types/SearchTypes'
import { useExpand, useInitProcessSummary } from 'hooks/useJuryo'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
    },
    renkeiTableRow: {
      backgroundColor: '#DCDCDC',
      '&not(:hover)': {
        backgroundColor: 'inherit',
      },
    },
  }),
)

type Props = {
  groupList: groupList[]
}

const O_TableJokenMobileSummary = ({ groupList }: Props) => {
  useEffect(() => {
    organismGroupLog('O_TableJokenMobileSummary')
  })
  const initProcess = useInitProcessSummary()
  useEffect(() => {
    initProcess()
  }, [])
  const classes = useStyles()
  const list = groupList
  const allCount = list.length

  const [open, _changeOpen] = useExpand()
  const headerRef = useRef<HTMLElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)
  const [tableHeight, setTableHeight] = useState(window.innerHeight)
  // 新しいtableHeightを取得する
  const getNewTableHeight = () => {
    const el = headerRef.current
    const el2 = bottomRef.current
    if (el && el2) {
      // テーブルの高さを画面上部から画面下固定の要素までの距離-画面上部からテーブル要素までの距離
      const newTableHeight = Math.ceil(el2.getBoundingClientRect().top - el.getBoundingClientRect().top)
      return newTableHeight
    }
    return 0
  }

  // 新しいtableHeightを取得して更新する必要があれば更新する
  const changeTableHeight = () => {
    const newTableHeight = getNewTableHeight()
    if (newTableHeight > 0 && tableHeight !== newTableHeight) setTableHeight(newTableHeight)
  }
  useEffect(() => {
    // 描画時にテーブルの高さを調整
    // 条件開閉したときアニメーションでレイアウトが変わるので、tableHeightの値が変わらなくなるまで0.2秒間隔で処理を実行
    let oldTableHeight = -1
    const timerId = setInterval(() => {
      if (oldTableHeight !== tableHeight) {
        const nowTableHeight = getNewTableHeight()
        if (oldTableHeight === nowTableHeight) {
          changeTableHeight()
          clearInterval(timerId)
        } else {
          oldTableHeight = getNewTableHeight()
        }
      } else {
        oldTableHeight = getNewTableHeight()
      }
    }, 200)
  }, [open])
  useEffect(() => {
    // ウィンドウサイズ変更時にchangeTableHeightを呼び出すようにリスナーに登録
    window.removeEventListener('resize', changeTableHeight)
    window.addEventListener('resize', changeTableHeight)
    return () => {
      window.removeEventListener('resize', changeTableHeight)
    }
  }, [tableHeight])

  // const getChecked = (joken: responseJuryo) => (isAllChecked ? true : checkListJoken.length <= 0 ? false : checkListJoken.some((r) => isUniqueJuryo(r, joken)))
  const table = (props: any) => <Table {...props} style={{ borderCollapse: 'separate' }} size="small" aria-label="purchases" />
  const tableHead = (props: any) => <TableHead {...props} ref={headerRef} />
  const tableRow = (props: any) => {
    const tableRowClasses = {
      [classes.renkeiTableRow]: props.item.RENKEI_KBN === 1,
    }
    return <TableRow hover className={clsx(tableRowClasses)} role="checkbox" {...props} />
  }
  const getComponent = useCallback(() => {
    return {
      Scroller: TableContainer,
      Table: table,
      TableHead: tableHead,
      TableRow: tableRow,
      TableBody: TableBody,
    }
  }, [])

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item style={{ width: '100%' }}>
          <O_TableBar count={allCount} buttonInfos={[]} pagination={false} />
        </Grid>
        {/* <Grid item style={{ width: '100%' }}> */}
        <TableVirtuoso
          style={{ height: tableHeight, overflowAnchor: 'none' }} // overflowAnchorは横スクロールした後に縦スクロールすると一番下まで自動でスクロールされる現象への対応
          data={list}
          components={getComponent()}
          fixedHeaderContent={() => <O_TableHeaderJokenMobileSummary />}
          itemContent={(_index, group) => {
            return <O_TableRowJokenMobileSummary group={group} />
          }}
        />
      </Grid>
      <div style={{ visibility: 'hidden', position: 'fixed', bottom: 0, height: '1.5em' }} ref={bottomRef}></div>
    </div>
  )
}

export default React.memo(O_TableJokenMobileSummary)
